import axios from "axios";
import type { AxiosError } from "axios";

const BASE_URL: string = process.env.REACT_APP_API_BASE_URL ?? "";

const isLoginRequest = (url = ""): boolean => {
  const normalizedUrl = String(url).toLowerCase();
  return normalizedUrl.includes("/auth/login");
};

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// ── Request interceptor ───────────────────────────────────────────────────────

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const role  = localStorage.getItem("role");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (role) {
      config.headers["x-role"] = role;
    }

    return config;
  },
  (error: unknown) => Promise.reject(error),
);

// ── Response interceptor ──────────────────────────────────────────────────────

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error: AxiosError<{ message?: string }>) => {
    const status     = error.response?.status;
    const requestUrl = (error.config?.url as string | undefined) ?? "";
    const message    =
      error.response?.data?.message ?? error.message ?? "An error occurred";

    if (status === 401 && !isLoginRequest(requestUrl)) {
      localStorage.clear();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    return Promise.reject({ status, message, raw: error.response?.data });
  },
);

export default axiosInstance;
